module.exports = __webpack_public_path__ + "static/quizbaker3-2f7860185f79b48a7e68c326c4e55530.png";